import { findIndex, filter, indexOf, map } from 'lodash';

import * as constants from './Dashboard.constants';
import * as services from './Dashboard.service';
import { UPDATE_USER_INFO_SUCCESS } from '../../constants';
const state = {
  Courses: [],
  Mocks: [],
  LastPlayedRecord: null,
  Pinzhibo: null,
  isRequest: false,

  reopenInfo: {},
  res_reopenSubmit: false,
};

const mutations = {
  [constants.GET_COURSES_SUCCESS](state, data) {
    state.Courses = data.courses;
    state.Mocks = data.events;
    state.LastPlayedRecord = data.lastPlayedRecord;
    state.Pinzhibo = data.pinzhibo;
  },

  [constants.OPEN_UP_COURSES_SUCCESS](state, data) {
    const { courseId } = data;
    const idx = findIndex(state.Courses[0].courses, (v) => v.courseId == courseId);
    state.Courses[0].courses[idx].hasRedeemed = true;
  },

  [constants.PUT_OFF_SUCCESS](state, data) {
    for (let i = 0, l = data.length; i < l; i++) {
      const { courseId } = data[i];
      const idx = findIndex(state.Courses[0].courses, (v) => v.courseId == courseId);
      state.Courses[0].courses[idx].deferInfo = data[i];
      state.Courses[0].courses[idx].expireDate = data[i].expireTime;
    }
  },

  [constants.PRE_OPEN_SUCCESS](state, data) {
    state.Courses = data.myCourses.courses;
  },

  [constants.GET_REOPEN_INFO_SUCCESS](state, reopenInfo) {
    if (null !== reopenInfo && undefined !== reopenInfo) {
      state.reopenInfo = reopenInfo;
    }
  },

  [constants.SET_RES_REOPEN_SUBMIT_SUCCESS](state, res_reopenSubmit) {
    state.res_reopenSubmit = res_reopenSubmit;
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async getCourses({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    try {
      const res = await services.getCourses(payload);
      if (res.data.data) {
        commit(constants.GET_COURSES_SUCCESS, res.data.data);
      }
    } catch (e) {
      commit(constants.GET_COURSES_SUCCESS, {
        courses: [],
        events: [],
      });
    }
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async openUpCourse({ commit }, payload) {
    const res = await services.openUpCourse(payload);
    if (res.data.data) {
      commit(constants.OPEN_UP_COURSES_SUCCESS, payload);
    }
  },

  async putOff({ commit }, payload) {
    const res = await services.putOff(payload);
    if (res.data.data) {
      commit(constants.PUT_OFF_SUCCESS, res.data.data);
    }
  },

  async preOpen({ commit }, payload) {
    const res = await services.preOpen(payload);
    if (res.data.data) {
      commit(constants.PRE_OPEN_SUCCESS, res.data.data);
      commit(
        UPDATE_USER_INFO_SUCCESS,
        { myCourses: res.data.data.myNavigateCourses },
        { root: true }
      );
    }
  },

  async getReopenInfo({ commit }) {
    const res = await services.getReopenInfo();
    commit(constants.GET_REOPEN_INFO_SUCCESS, res.data.data);
  },

  async reopenSubmit({ commit }, payload) {
    const res = await services.reopenSubmit(payload);
    commit(constants.SET_RES_REOPEN_SUBMIT_SUCCESS, res.data.data);
  },
};

const getters = {
  Courses: (state) => state.Courses,
  Mocks: (state) =>
    Array.isArray(state.Mocks) && state.Mocks.length > 0
      ? state.Mocks.filter((v) => v.examStatus == 2)
      : [],
  LastPlayedRecord: (state) => state.LastPlayedRecord,
  Pinzhibo: (state) => state.Pinzhibo,
  mainGroup: (state, getters) => {
    if (getters.Courses && getters.Courses.length > 0) {
      const mainGroup = getters.Courses.find((course) => course.groupType == 1);
      const coursesNotHasRedeemed = filter(mainGroup.courses, (course) => !course.hasRedeemed);
      const coursesNotHasRedeemedCourseId = map(coursesNotHasRedeemed, (course) => course.courseId);
      const coursesHasRedeemed = filter(
        mainGroup.courses,
        (course) =>
          course.hasRedeemed && -1 === indexOf(coursesNotHasRedeemedCourseId, course.courseId)
      );
      return {
        ...mainGroup,
        coursesHasRedeemed,
        coursesNotHasRedeemed,
      };
    } else {
      return {
        courses: [],
        coursesHasRedeemed: [],
        coursesNotHasRedeemed: [],
      };
    }
  },
  financeGroup: (state, getters) =>
    (getters.Courses &&
      getters.Courses.length > 0 &&
      getters.Courses.find((course) => course.groupType == 2)) || {
      courses: [],
    },
  eventGroup: (state, getters) =>
    (getters.Courses &&
      getters.Courses.length > 0 &&
      getters.Courses.find((course) => course.groupType == 3)) || {
      courses: [],
    },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
